import s from './EmojiModal.module.scss';
import EmojiPicker from 'emoji-picker-react';
import { Theme } from 'emoji-picker-react';
import { EmojiStyle } from 'emoji-picker-react';

export const EmojiModal = ({show, setValue, close}: any) => {

    // ### State

    // ### Effects

    // ### Functions

    // ### Views

    return(
        <div className={`${s.wrapper} ${show ? s.show : ''}`}>
            <div className={s.back} onClick={close}></div>
            <div className={s.modal}>
            <EmojiPicker 
                onEmojiClick={(value) => {
                    setValue(value.emoji)
                    close()
                }}
                searchDisabled
                theme={Theme.DARK}
                emojiStyle={EmojiStyle.APPLE}
            />
            </div>
        </div>
    )
}